import {Deserializable} from "./deserializable.model";

export class SystemLogTypeDataSectorType {

   public log_type_data_sector_type_id: number;
   public log_type_data_sector_type_name?: string;
   public log_type_data_sector_type_description?: string;
   public severity?: string;
   public danger_scale?: number;
   public system_automation_id?: number;
   public system_automation_array?: any;
   public log_insert_name?: string;
   public log_insert_template?: string;
   public log_type_data_sector_type_colour?: string;
   public log_type_data_sector_type_icon?: string;
   public log_type_data_sector_id?: number;
   public log_level_id?: number;

   public created_tested?: number;
   public notes?: string;
   public is_active?: number;

  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): SystemLogTypeDataSectorType {
    Object.assign(this, input);

    return this;
  }

  /*
log_type_data_sector_type_name
log_type_data_sector_type_description


log_type_data_sector_type_id

log_type_data_sector_type_name
log_type_data_sector_type_description

severity
danger_scale
system_automation_id
system_automation_array
log_insert_name
log_insert_template
log_type_data_sector_type_colour
log_type_data_sector_type_icon
log_type_data_sector_id
log_level_id
created_tested
notes
  */

}
